document.addEventListener('DOMContentLoaded', () => {

    const selector = document.querySelector('.edge-currency-switcher__select');

    if (!selector) return;

    const currencyNames = {
        EUR: "Euros",
        USD: "US Dollars",
        GBP: "British Pounds",
        SEK: "Swedish Kronor",
        NOK: "Norwegian Kroner",
        DKK: "Danish Kroner",
        CHF: "Swiss Francs",
        CAD: "Canadian Dollars",
        AUD: "Australian Dollars",
        NZD: "New Zealand Dollars",
        JPY: "Japanese Yen"
    };

    function updateCurrencyNotices() {

        document.querySelectorAll('[data-currency-estimate-notice]').forEach(notice => {

            const currencyName = notice.querySelector('.currency-name');

            if (!currencyName) return;

            const currency = selector.value;

            currencyName.textContent = currencyNames[currency] || currency;

            notice.classList.toggle('hidden', currency === 'EUR');

        });

    }

    updateCurrencyNotices();

    selector.addEventListener('change', updateCurrencyNotices);

});